import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendarSchedule = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Calendar_Schedule",
	"data-name": "Calendar,Schedule",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_16698",
		"data-name": "Group 16698",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12424",
				"data-name": "Path 12424",
				d: "M16,2V6",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12425",
				"data-name": "Path 12425",
				d: "M8,2V6",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12426",
				"data-name": "Path 12426",
				d: "M3,9H21",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12427",
				"data-name": "Path 12427",
				d: "M19,4H5A2,2,0,0,0,3,6V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V6A2,2,0,0,0,19,4Z",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12428",
				"data-name": "Path 12428",
				d: "M7,13H17",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12429",
				"data-name": "Path 12429",
				d: "M7,17h5",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12430",
				"data-name": "Path 12430",
				d: "M16,21V18a1,1,0,0,1,1-1h4",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			})
		]
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_12431",
		"data-name": "Path 12431",
		d: "M0,0H24V24H0Z",
		fill: "none",
		fillRule: "evenodd"
	})]
});
export default SvgCalendarSchedule;
